import { default as ModalProvider } from "react-modal"

interface ConfirmModalProps {
    isOpen: boolean
    title: string
    message?: string
    confirmText?: string
    cancelText?: string
    loading?: boolean
    tone?: "danger" | "primary"
    onConfirm: () => void
    onCancel: () => void
}

const ConfirmModal = ({
    isOpen,
    title,
    message,
    confirmText = "Șterge",
    cancelText = "Anulează",
    loading = false,
    tone = "danger",
    onConfirm,
    onCancel,
}: ConfirmModalProps) => {
    const isPrimary = tone === "primary"
    return (
        <ModalProvider
            appElement={document.getElementById("root")!}
            isOpen={isOpen}
            onRequestClose={() => { if (!loading) onCancel() }}
            className="mx-4 my-auto w-full max-w-[420px] rounded-2xl bg-white outline-none"
            overlayClassName="fixed inset-0 z-[60] flex items-center justify-center bg-gray-800/60 p-4"
        >
            <div className="p-6 sm:p-7">
                <div className={`mx-auto flex h-14 w-14 items-center justify-center rounded-full ${isPrimary ? "bg-figmaPrimary/10 text-figmaPrimary" : "bg-figmaContrast/10 text-figmaContrast"}`}>
                    {isPrimary ? (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-7 w-7">
                            <path d="M9 12l2 2 4-4" />
                            <circle cx="12" cy="12" r="9" />
                        </svg>
                    ) : (
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-7 w-7">
                            <path d="M3 6h18" />
                            <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                            <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                            <path d="M10 11v6M14 11v6" />
                        </svg>
                    )}
                </div>

                <h3 className="mt-4 text-center text-lg font-bold text-figmaBlack">{title}</h3>
                {message && (
                    <p className="mt-2 text-center text-sm text-figmaDarkGray leading-relaxed">{message}</p>
                )}

                <div className="mt-6 flex gap-3">
                    <button
                        type="button"
                        onClick={onCancel}
                        disabled={loading}
                        className="flex-1 rounded-xl bg-figmaLightGray px-4 py-3 text-sm font-semibold text-figmaBlack transition-colors hover:bg-figmaDarkBg/30 disabled:opacity-50"
                    >
                        {cancelText}
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        disabled={loading}
                        className={`flex flex-1 items-center justify-center gap-2 rounded-xl px-4 py-3 text-sm font-semibold text-white transition-opacity hover:opacity-90 disabled:opacity-50 ${isPrimary ? "bg-figmaPrimary" : "bg-figmaContrast"}`}
                    >
                        {loading ? (
                            <span className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
                        ) : confirmText}
                    </button>
                </div>
            </div>
        </ModalProvider>
    )
}

export default ConfirmModal
